export default __webpack_public_path__ + "static/media/Diaz.4c31e063.jpg";